import type { ImageCTAStyles } from "../ImageCTA.d";

export const ImageCTAStylesMobile: ImageCTAStyles = {
  basic: {
    container: {
      bg: "primary.900",
      color: "white",
      rounded: "xl",
    },
    image: { minH: "200px" },
    textContainer: {
      borderTop: "16px solid",
      borderColor: "danger.500",
      p: 6,
    },
    heading: {
      pb: 6,
      variant: "h3",
      as: "h3",
    },
    button: {},
  },

  ahPlus: {
    container: {
      bg: "greyscale.400",
      color: "primary.900",
      rounded: "lg",
    },
    image: {
      bgColor: "greyscale.500",
      bgPosition: "top",
      minH: "187px",
    },
    textContainer: { p: 5, py: 6 },
    heading: {
      pb: 4,
      variant: "h5",
      as: "h5",
      lineHeight: "short",
    },
    button: {
      w: "full",
      variant: "primaryAlt",
      size: "sm",
    },
  },
};
